
import { Options, Vue } from 'vue-class-component';
import Slider from '@vueform/slider'
import SelectInput from "@/components/SelectInput.vue";
import HorizontalPanel from "@/components/HorizontalPanel.vue";
import {Prop} from "vue-property-decorator";
import {Tour} from "@/Tour";
import filters from "@/data/filters.json"
import Hotel from "@/Hotels";
import {IFilter, RangeFilter, SelectFilter, StarsFilter} from "@/Filters";
import "@/assets/icomoon/style.css"
import {LevelTraverDriver} from "@/driver/LevelTravel";
import {TravelataDriver} from "@/driver/Travelata";
import {SletatRuDriver} from "@/driver/SletatRu";
import properties from "@/data/properties.json";
import * as hotelsApi from "@/services/hotels";
import * as toursApi from "@/services/tours";
import {SearchParams} from "@/services/tours";
import {Country} from "@/helpers/country";
import {DateLocalization} from "@/helpers/DateLocalization";

@Options({
  components: {
    Slider,
    SelectInput,
    HorizontalPanel
  },
})
export default class extends Vue {
  sort_by = "min_price";
  sort_asc = false;
  founded = -1;
  paginate = 10;
  filters_showed = false;
  currentCountry!: Country;
  dateLocalization = DateLocalization;

  hotels: Hotel[] = [];

  @Prop({required: true})
  search_data!: SearchParams;

  filters: IFilter[] = [];

  changeSort(sort_by: string) {
    if(this.sort_by === sort_by){
      this.sort_asc = !this.sort_asc;
    }else{
      this.sort_by = sort_by;
      this.sort_asc = true;
    }
  }

  async mounted(){
    this.currentCountry = new Country(this.search_data.to);
    const selector = document.querySelector("[data-country-name]");
    if(selector){
      const parent = this.currentCountry.getParent();
      if(parent){
        selector.innerHTML = `Пляжные туры ${this.currentCountry.getDeclName()} в ${parent.getDeclName()}`
      }else{
        selector.innerHTML = `Пляжные туры в ${this.currentCountry.getDeclName()}`
      }
    }
    let city_id: {[key:string]: string};

    try {
      const response = await hotelsApi.index(this.search_data.to);
      this.hotels = response.hotels;
      city_id = response.city;
    }catch (e: any) {
      return this.$emit("abort",e.message)
    }

    const tours = await toursApi.index(
        this.search_data.from,
        this.search_data.to,
        this.search_data.start_date,
        this.search_data.nights_count,
        this.search_data.adults_count
    );

    const out_tours = [];

    tours["LevelTravel"] && out_tours.push(...LevelTraverDriver(tours["LevelTravel"]));
    tours["Travelata"] && out_tours.push(...TravelataDriver(tours["Travelata"]));
    tours["Sletat"] && out_tours.push(...SletatRuDriver(tours["Sletat"]));

    for(let tour of out_tours){

      tour.rating /= 2;
      let isApplied = false;

      for(const hotel of this.hotels){
        if(hotel.name === tour.name){
          isApplied = true;
          hotel.tours.push(tour);
          if(!hotel.picture){
            hotel.picture = tour.image.full_size;
          }
          if(!hotel.description){
            hotel.description = tour.desc;
          }
          if(!hotel.stars){
            hotel.stars = tour.stars;
          }

          for(const key of Object.keys(properties)){
            if(key in tour && tour[key as keyof Tour]){
              let card = (properties as any)[key][tour[key as keyof Tour].toString()];
              hotel.extras.push(card);
            }
          }
        }
      }

      if(!isApplied) {
        const hotel = new Hotel(tour.name,tour.image.full_size);
        if(!hotel.description){
          hotel.description = tour.desc;
        }
        if(!hotel.stars){
          hotel.stars = tour.stars;
        }

        for(const key of Object.keys(properties)){
          if(key in tour && tour[key as keyof Tour]){
            let card = (properties as any)[key][tour[key as keyof Tour].toString()];
            hotel.extras.push(card);
          }
        }
        hotel.tours.push(tour);
        this.hotels.push(hotel);
      }
    }

    this.hotels = this.hotels.filter((hotel)=>{
      return hotel.tours.length > 0;
    })

    if(out_tours.length <= 0){
      return this.$emit("abort","Мы ничего не смогли найти. Попробуйте применить другие фильтры")
    }

    this.addFilter(new SelectFilter("Город","city_id",city_id));
    this.recalculateFilters();
    this.applyFilter();
  }

  addFilter(filter: IFilter){
    const params = new URLSearchParams(window.location.search);
    if(filter.initialize(this.hotels)){
      if(params.has(filter.key)){
        filter.from_string(params.get(filter.key)!);
      }
      this.filters.push(filter);
    }
  }

  recalculateFilters(){

    for(let filter of filters){
      if(filter.type === "range"){
        const range_filter = new RangeFilter(filter.name,filter.key);
        filter.symbol && range_filter.setSymbol(filter.symbol);
        this.addFilter(range_filter);
      }
      if(filter.type === "stars_range"){
        const stars_filter = new StarsFilter(filter.name,filter.key,filter.max || 10,filter.min || 0);
        this.addFilter(stars_filter);
      }
      if(filter.type === "select" && filter.values){
        const select_filter = new SelectFilter(filter.name,filter.key as keyof Hotel,filter.values);
        this.addFilter(select_filter);
      }
    }
  }

  get appliedFilters(){
    return this.filters.filter(filter=> filter.changed());
  }

  get sortedTours(){
    let hotels = this.hotels;

    for(let filter of this.filters){

      const temp = [];

      for (const hotel of hotels){
        if(filter.test(hotel)){
          temp.push(hotel);

        }
      }

      hotels = temp;
    }

    for(let filter of this.filters){

      if(filter instanceof SelectFilter){
        filter.resetSuccesses();

        for (const hotel of hotels){
          filter.test(hotel)
        }
      }
    }

    hotels = hotels.sort((a,b) => {

      if(this.sort_asc){
        let min_a = 999999;
        let min_b = 999999;

        a.tours.map(tour=>{
          min_a = Math.min(tour[this.sort_by as keyof Tour] as number,min_a);
        });

        b.tours.map(tour=>{
          min_b = Math.min(tour[this.sort_by as keyof Tour] as number,min_b);
        });

        return min_b - min_a;
      }else{

        let max_a = 0;
        let max_b = 0;

        a.tours.map(tour=>{
          max_a = Math.max(tour[this.sort_by as keyof Tour] as number,max_a);
        });

        b.tours.map(tour=>{
          max_b = Math.max(tour[this.sort_by as keyof Tour] as number,max_b);
        });

        return max_a - max_b;
      }
    })

    return hotels;
  }

  applyFilter(){
    setTimeout(()=>{

      const params = new URLSearchParams(window.location.search);
      for (const filter of this.filters){
        if(filter.changed()){
          params.set(filter.key,filter.to_string());
        }else{
          params.delete(filter.key);
        }
      }
      history.pushState(null,"",window.location.pathname + '?' + params.toString());

    },50);
  }

  loadMore(){
    this.paginate += 10;
  }

  showFilters(){
    this.filters_showed = true;
  }
  hideFilters(){
    this.filters_showed = false;
  }

  getNumericValue(value: number){
    if(value > 1000){
      return (value / 1000).toFixed(1) + " тыс.";
    }
    return value;
  }
}
